<template>
    <div class="detailsContainer">
        <div>
            <h1>Kontakt</h1>
        </div>
        <div>
            <div>
                <div v-html="footer"></div>
                <a href="https://facebook.com/arabiuro" target="_blank" style="height: 50px; width: 200px; display: block; margin: 0 auto;">
                    <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="200px" height="50px" viewBox="0 0 349 93" xml:space="preserve">
                        <defs>
                            <linearGradient id="blueGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                                <stop offset="0%" style="stop-color:#2852A0;stop-opacity:1"/>
                                <stop offset="100%" style="stop-color:#0f203e;stop-opacity:1"/>
                            </linearGradient>
                        </defs>
                        <path fill-rule="evenodd" clip-rule="evenodd" fill="#FFFFFF" stroke="#000000" stroke-width="2" stroke-miterlimit="10"
                            d=" M302.244,4.074H47.126c-23.482,0-42.52,19.037-42.52,42.52c0,23.482,19.037,42.52,42.52,42.52h255.118 c23.483,0,42.52-19.037,42.52-42.52C344.764,23.111,325.728,4.074,302.244,4.074z"/>
                        <circle fill-rule="evenodd" clip-rule="evenodd" fill="url(#blueGradient)" stroke="" stroke-width="4" stroke-miterlimit="10" cx="47.126" cy="46.594" r="42.52"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" fill="#FFFFFF"
                            d="M53.337,33.344c1.239-0.041,2.476-0.007,3.717-0.012 c0.152,0,0.305,0,0.514,0v-6.444c-0.664-0.067-1.354-0.162-2.048-0.196c-1.272-0.055-2.546-0.118-3.817-0.091 c-1.941,0.041-3.78,0.513-5.384,1.664c-1.842,1.327-2.853,3.187-3.235,5.382c-0.16,0.908-0.204,1.844-0.225,2.766 c-0.036,1.447-0.007,2.895-0.005,4.341v0.542h-6.168v7.199h6.132v18.1h7.491V48.522h6.112c0.314-2.395,0.62-4.763,0.938-7.232 c-0.491,0-0.932,0-1.373,0c-1.738,0.004-5.727,0-5.727,0s0.02-3.569,0.063-5.118C50.378,34.053,51.638,33.407,53.337,33.344z"/>
                        <path d="M134.431,28.826h3.792l-14.256,34.368h-3.792L134.431,28.826z"/>
                        <path
                            d="M142.878,62.906c-1.408-0.704-2.496-1.672-3.264-2.904c-0.769-1.231-1.152-2.632-1.152-4.2 c0-2.592,0.976-4.615,2.928-6.072c1.952-1.456,4.416-2.184,7.393-2.184c1.472,0,2.839,0.161,4.104,0.48 c1.264,0.32,2.232,0.688,2.904,1.104v-1.488c0-1.824-0.641-3.288-1.92-4.392c-1.28-1.104-2.896-1.656-4.848-1.656 c-1.377,0-2.641,0.296-3.792,0.888c-1.152,0.592-2.064,1.416-2.736,2.472l-3.072-2.304c0.96-1.472,2.28-2.624,3.96-3.456 c1.681-0.832,3.544-1.248,5.592-1.248c3.328,0,5.944,0.872,7.849,2.616c1.903,1.744,2.855,4.12,2.855,7.128v15.504h-3.888V59.69 h-0.192c-0.704,1.184-1.76,2.192-3.168,3.024s-2.992,1.248-4.752,1.248C145.886,63.962,144.287,63.609,142.878,62.906z M151.903,59.306c1.184-0.703,2.128-1.647,2.832-2.832c0.703-1.183,1.056-2.479,1.056-3.888c-0.768-0.512-1.712-0.928-2.832-1.248 c-1.12-0.319-2.304-0.48-3.552-0.48c-2.24,0-3.929,0.464-5.064,1.392c-1.136,0.928-1.704,2.128-1.704,3.6 c0,1.344,0.512,2.433,1.536,3.264c1.024,0.833,2.32,1.248,3.889,1.248C149.438,60.362,150.718,60.01,151.903,59.306z"/>
                        <path
                            d="M165.342,38.714h3.888v3.936h0.191c0.48-1.344,1.408-2.456,2.784-3.336c1.376-0.88,2.815-1.32,4.32-1.32 c1.12,0,2.08,0.161,2.88,0.48v4.416c-1.024-0.511-2.177-0.768-3.456-0.768c-1.185,0-2.272,0.336-3.264,1.008 c-0.992,0.672-1.784,1.577-2.376,2.712c-0.593,1.136-0.889,2.36-0.889,3.672v13.68h-4.079V38.714z"/>
                        <path
                            d="M185.407,62.906c-1.408-0.704-2.496-1.672-3.264-2.904c-0.769-1.231-1.152-2.632-1.152-4.2 c0-2.592,0.976-4.615,2.928-6.072c1.952-1.456,4.416-2.184,7.393-2.184c1.472,0,2.839,0.161,4.104,0.48 c1.264,0.32,2.232,0.688,2.904,1.104v-1.488c0-1.824-0.641-3.288-1.92-4.392c-1.28-1.104-2.896-1.656-4.848-1.656 c-1.377,0-2.641,0.296-3.792,0.888c-1.152,0.592-2.064,1.416-2.736,2.472l-3.072-2.304c0.96-1.472,2.28-2.624,3.96-3.456 c1.681-0.832,3.544-1.248,5.592-1.248c3.328,0,5.944,0.872,7.848,2.616c1.904,1.744,2.855,4.12,2.855,7.128v15.504h-3.887V59.69 h-0.192c-0.704,1.184-1.76,2.192-3.168,3.024s-2.992,1.248-4.752,1.248C188.415,63.962,186.815,63.609,185.407,62.906z M194.431,59.306c1.184-0.703,2.128-1.647,2.832-2.832c0.703-1.183,1.056-2.479,1.056-3.888c-0.768-0.512-1.712-0.928-2.832-1.248 c-1.12-0.319-2.304-0.48-3.552-0.48c-2.24,0-3.929,0.464-5.064,1.392c-1.136,0.928-1.704,2.128-1.704,3.6 c0,1.344,0.512,2.433,1.536,3.264c1.024,0.833,2.32,1.248,3.889,1.248C191.966,60.362,193.247,60.01,194.431,59.306z"/>
                        <path
                            d="M215.286,62.69c-1.488-0.848-2.6-1.879-3.336-3.096h-0.191v3.6h-3.889V28.826h4.08v10.128l-0.191,3.408h0.191 c0.736-1.248,1.848-2.296,3.336-3.144c1.488-0.848,3.16-1.272,5.016-1.272c2.176,0,4.16,0.56,5.953,1.68 c1.791,1.121,3.199,2.672,4.223,4.656c1.023,1.984,1.537,4.208,1.537,6.672c0,2.496-0.514,4.728-1.537,6.696 c-1.023,1.968-2.432,3.512-4.223,4.632c-1.793,1.12-3.777,1.68-5.953,1.68C218.446,63.962,216.774,63.537,215.286,62.69z M223.806,59.114c1.248-0.768,2.248-1.864,3-3.288c0.752-1.423,1.129-3.048,1.129-4.872c0-1.824-0.377-3.448-1.129-4.872 s-1.752-2.52-3-3.288s-2.576-1.152-3.984-1.152s-2.734,0.384-3.982,1.152s-2.24,1.856-2.977,3.264 c-0.736,1.409-1.104,3.041-1.104,4.896c0,1.856,0.367,3.488,1.104,4.896c0.736,1.409,1.729,2.496,2.977,3.264 s2.574,1.152,3.982,1.152S222.558,59.882,223.806,59.114z"/>
                        <path
                            d="M236.862,33.338c-0.576-0.576-0.863-1.264-0.863-2.064c0-0.8,0.287-1.48,0.863-2.04c0.576-0.56,1.264-0.84,2.064-0.84 c0.799,0,1.488,0.28,2.064,0.84c0.576,0.56,0.863,1.24,0.863,2.04c0,0.8-0.281,1.488-0.84,2.064 c-0.561,0.576-1.256,0.864-2.088,0.864C238.126,34.202,237.438,33.914,236.862,33.338z M236.911,38.714h4.031v24.48h-4.031V38.714 z"/>
                        <path
                            d="M249.511,61.37c-1.553-1.728-2.328-4.144-2.328-7.248V38.714h4.08v14.784c0,2.336,0.527,4.048,1.584,5.136 c1.055,1.088,2.479,1.632,4.271,1.632c1.375,0,2.6-0.367,3.672-1.104c1.072-0.735,1.904-1.695,2.496-2.88 c0.592-1.184,0.889-2.431,0.889-3.744V38.714h4.08v24.48h-3.889v-3.552h-0.191c-0.672,1.216-1.746,2.24-3.217,3.072 c-1.473,0.832-3.041,1.248-4.703,1.248C253.31,63.962,251.062,63.098,249.511,61.37z"/>
                        <path
                            d="M274.302,38.714h3.889v3.936h0.191c0.48-1.344,1.408-2.456,2.783-3.336c1.377-0.88,2.816-1.32,4.32-1.32 c1.121,0,2.08,0.161,2.881,0.48v4.416c-1.025-0.511-2.178-0.768-3.457-0.768c-1.184,0-2.271,0.336-3.264,1.008 s-1.783,1.577-2.375,2.712c-0.594,1.136-0.889,2.36-0.889,3.672v13.68h-4.08V38.714z"/>
                        <path
                            d="M295.661,62.234c-1.92-1.152-3.416-2.72-4.488-4.704c-1.072-1.984-1.607-4.176-1.607-6.576c0-2.4,0.535-4.591,1.607-6.576 c1.072-1.984,2.568-3.552,4.488-4.704s4.08-1.728,6.48-1.728s4.561,0.576,6.48,1.728s3.414,2.72,4.488,4.704 c1.07,1.984,1.607,4.176,1.607,6.576c0,2.4-0.537,4.592-1.607,6.576c-1.074,1.984-2.568,3.552-4.488,4.704s-4.08,1.728-6.48,1.728 S297.581,63.386,295.661,62.234z M306.341,59.138c1.297-0.751,2.336-1.832,3.121-3.24c0.783-1.408,1.176-3.056,1.176-4.944 c0-1.888-0.393-3.535-1.176-4.944c-0.785-1.408-1.824-2.488-3.121-3.24c-1.295-0.751-2.695-1.128-4.199-1.128 s-2.912,0.376-4.225,1.128c-1.313,0.752-2.359,1.832-3.145,3.24c-0.783,1.409-1.176,3.056-1.176,4.944 c0,1.889,0.393,3.537,1.176,4.944c0.785,1.408,1.832,2.488,3.145,3.24c1.313,0.752,2.721,1.128,4.225,1.128 S305.046,59.89,306.341,59.138z"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" fill="none" stroke="#000000" stroke-width="2" stroke-miterlimit="10"
                            d=" M302.244,4.074H47.126c-23.482,0-42.52,19.037-42.52,42.52c0,23.482,19.037,42.52,42.52,42.52h255.118 c23.483,0,42.52-19.037,42.52-42.52C344.764,23.111,325.728,4.074,302.244,4.074z"/>
                    </svg>
                </a>
            </div>
            <div class="contactForm">
                <label> Przedstaw się (Imię i/lub Nazwisko)
                    <input type="text" v-model="form.name">
                </label>
                <label> Telefon do kontaktu
                    <input type="text" v-model="form.telephone">
                </label>
                <label> Email do kontaktu
                    <input type="text" v-model="form.email">
                </label>
                <label> Treść korespondencji
                    <textarea v-model="form.content"></textarea>
                </label>
                <button @click="sendForm">Wyślij</button>
            </div>
        </div>
    </div>
</template>

<script>
import textParser from "@/textParser";

const getFooter = async () => {
    const footerData = await fetch(
        process.env.VUE_APP_XHR,
        {
            method: 'POST',
            mode: 'cors',
            cache: 'no-cache',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                mode: 'cms',
                type: 'footer'
            })
        }
    )

    return await footerData.json();
};

export default {
    name: "Footer",
    data () {
        return {
            footer: null,
            form: {
                name: '',
                telephone: '',
                email: '',
                content: ''
            }
        }
    },
    methods: {
        async sendForm () {
            console.log(this.form);

            try {
                this.form.name = this.form.name.trim();
                this.form.telephone = this.form.telephone.trim().replace(/[^+0-9]+/g, "");
                this.form.email = this.form.email.trim().toLowerCase();
                this.form.content = this.form.content.trim();

                if (this.form.name == '' || this.form.name.length > 100 || this.form.name.length < 3) {
                    throw 'Proszę uzupełnić pole "przedstaw się" (maksymalnie 100 znaków)';
                }

                if (this.form.telephone == '' || this.form.telephone.length < 9) {
                    throw 'Proszę podać prawidłowy numer telefonu';
                }
                const reg = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                if (this.form.email == '' || ! reg.test(this.form.email)) {
                    throw 'Proszę podać prawidłowy adres email';
                }

                if (this.form.content == '' || this.form.content.length < 20) {
                    throw 'Proszę wpisać treść wiadomości';
                }

                let response = await fetch(
                    process.env.VUE_APP_XHR,
                    {
                        method: 'POST',
                        mode: 'cors',
                        cache: 'no-cache',
                        headers: {
                            'Accept': 'application/json',
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify({
                            mode: 'send_mail',
                            data: this.form
                        })
                    }
                )
                await response.json();
                alert('Wiadomość została wysłana');
                this.form.name = '';
                this.form.telephone = '';
                this.form.email = '';
                this.form.content = '';
            } catch (err) {
                alert(err);
            }
        }
    },
    async mounted () {
        let footerText = await getFooter();
        this.footer = textParser(footerText.footer);
    }
}
</script>

<style lang="scss" scoped>
.detailsContainer {
    width: 100%;
    background: #333333;
    min-height: 200px;
    padding: 6vh 0;

    > div {
        max-width: 1200px;
        margin: 0 auto;
        color: #eeeeee;
        display: flex;
        justify-content: space-between;
        font: 16px/24px "Roboto Condensed";

        > h1 {
            text-align: center;
            font: 32px 'Google Sans';
            line-height: calc(32px + 3vh);
            color: #f11;
            text-transform: uppercase;
            width: 100%;
        }

        > div {
            max-width: calc(600px - 4vw);
            margin: 3vh 0;

            &.contactForm {
                width: 100%;

                button {
                    font-size: 16px;
                    font-family: "Roboto Condensed", serif;
                    padding: 10px 40px;
                    border: none;
                    background-color: var(--button-gray);
                    cursor: pointer;
                    text-transform: uppercase;
                }

                button:hover {
                    background-color: var(--button-red);
                }

                label {
                    width: 100%;
                    display: block;
                    margin: 1vw 0;
                }

                input[type=text] {
                    display: block;
                    padding: 0 10px;
                    margin: 0 0 10px;
                    height: 32px;
                    width: 100%;
                    font: 16px/32px "Roboto Condensed";
                    border: solid 1px var(--border-color);
                }

                input[type=text]:focus {
                    border-color: var(--border-collor-active);
                }

                textarea {
                    resize: none;
                    font: 16px "Roboto Condensed";
                    padding: 10px;
                    width: 100%;
                    height: 20vh;
                    border-color: var(--border-collor);
                }

                textarea:focus {
                    border-color: var(--border-collor-active);
                }
            }
        }
    }
}
</style>